module.exports = __webpack_public_path__ + "media/arrive.a9e27dac.mp3";